import type { GridRowSelectionModel } from '@mui/x-data-grid/models/gridRowSelectionModel';
import { DutyLineFlag } from 'components/enums';
import type { BulkDeps } from '../HoursTable.types';
import type { DutyMutationType } from './useMutateDutyLinesInBulk.types';
import { DutyMutationTypeEnum } from './useMutateDutyLinesInBulk.types';

export function useBulkActions({
  apiRef,
  selectedRows,
  setSelectedRows,
  employeeId,
  isEmployeePortal,
  mutateDutyLinesInBulk
}: BulkDeps) {
  'use memo';

  const clearSelection = () => {
    const emptySelection: GridRowSelectionModel = {
      type: 'include',
      ids: new Set()
    };
    apiRef?.current?.setRowSelectionModel(emptySelection);
    setSelectedRows([]);
  };

  const handleBulkActions = async (type: DutyMutationType) => {
    if (!selectedRows.length) return;

    const dutyLineIds = selectedRows.reduce<number[]>((acc, row: any) => {
      if (row.requestId != null) acc.push(row.requestId);
      return acc;
    }, []);

    if (!dutyLineIds.length) {
      clearSelection();
      return;
    }

    if (type === DutyMutationTypeEnum.ADD) {
      await mutateDutyLinesInBulk({
        employeeId,
        isEmployeePortal,
        dutyLineIds,
        flags: [DutyLineFlag.APPROVED],
        type: DutyMutationTypeEnum.ADD
      });
    } else {
      await mutateDutyLinesInBulk({
        employeeId,
        isEmployeePortal,
        dutyLineIds,
        type
      });
    }
    clearSelection();
  };

  return { handleBulkActions, clearSelection };
}
